import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-login',
  imports: [],
  templateUrl: './icon-login.component.html',
  styleUrl: './icon-login.component.scss',
})
export class IconLoginComponent {
  @Input() color: string = '#fff';
  @Input() size: string = '25px';
}
